export default __webpack_public_path__ + "/dist/images/cart-icon.svg";